import { useI18n } from '../i18n/i18n';
import { CountDown } from './Countdown';

import './SecondStrip.css';
import { isPostWedding, isToday } from '../after';

export function SecondStrip() {
    const t = useI18n();

    return <section className="half dark second">
        <p className="white medium center">
            {isPostWedding()
                ? t.secondStrip.daysPassed
                : isToday() ? '' : t.secondStrip.daysUntil}
        </p>
        <CountDown
            i18n={t}
            weddingDate="2025-05-31T07:00:00Z"
            dayStart="2025-05-31T07:00:00Z"
            dayEnd="2025-06-01T23:59:00Z" />
    </section>;
}
